import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { DogYearsScreen, DogYearsScreenProps } from 'shared/screens/dog-years';

export function DogYearsPage(props: DogYearsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.forPage(t('dog_years.pages.title'), t('dog_years.pages.description'))}
    >
      <DogYearsScreen {...props} />
    </Page>
  );
}
